import CardModal, { CardModalProps } from '@anm/components/modals/CardModal';
import { FC } from 'react';
import styled from 'styled-components';

import ProjectPreview, { ProjectPreviewProps } from './ProjectPreview';

export type ProjectPreviewModalProps = CardModalProps & ProjectPreviewProps;

const CardModalWrapper = styled(CardModal)`
  background-color: transparent;
  padding: 5px;
`;
const ProjectPreviewModal: FC<ProjectPreviewModalProps> = ({ onModalClose, ...previewProps }) => (
  <CardModalWrapper cardSettings={{ isPadding: false, variant: 'transparent' }} onModalClose={onModalClose}>
    <ProjectPreview {...previewProps} />
  </CardModalWrapper>
);

export default ProjectPreviewModal;
